import '../../scss/acf-blocks/block-plaid-search.scss';
import {
    initFormValidation,
    initializeCaptcha,
    showSubmitError,
    recaptchaSiteVerify,
} from '../components/form-validation';

/**
 * Fetches bank names from the Plaid API based on user input and updates the HTML dynamically.
 *
 * @async
 */
const fetchData = async () => {
    try {
        // Assuming 'bank_name' is the ID of your input field
        /** @type {string} */
        const bankName = document.getElementById('bank_name').value;

        const url = 'https://sandbox.plaid.com/institutions/search';
        const PLAID_CLIENT_ID = '6571a9551fc749001b815f2b';
        const PLAID_SECRET = '10b96cdfb2e2bfb7e5d56b2bb23447';
        const headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };

        const data = {
            client_id: PLAID_CLIENT_ID,
            secret: PLAID_SECRET,
            query: bankName,
            products: ['transactions'],
            country_codes: ['US', 'CA'],
        };

        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(data),
        });

        /**
         * @type {{institutions: {name: string}[]}}
         */
        const plaidResponse = await response.json();
        const { institutions } = plaidResponse;

        // Assuming you have an element with the id 'js-plaid-result' to update
        /** @type {HTMLElement} */
        const resultsContainer = document.querySelector('.js-plaid-result');

        // Clear previous results
        resultsContainer.innerHTML = '';

        if (institutions.length > 0) {
            const title = document.createElement('h3');
            title.classList.add('section-plaid-search__results-title', 'mb-2');
            title.textContent = 'Plaid supports:';
            resultsContainer.appendChild(title);

            const list = document.createElement('ul');
            list.classList.add('section-plaid-search__results-wrapper');

            institutions.forEach((bank) => {
                const listItem = document.createElement('li');
                listItem.classList.add('section-plaid-search__results-item');
                listItem.textContent = bank.name;
                list.appendChild(listItem);
            });

            resultsContainer.appendChild(list);
        } else {
            const noResults = document.createElement('h3');
            noResults.classList.add(
                'section-plaid-search__results-title',
                'mobile-center'
            );
            noResults.textContent = 'No results found';
            resultsContainer.appendChild(noResults);
        }
    } catch (error) {
        // Handle errors here
        console.error('Error:', error);
    }
};

const initPlaidSearch = () => {
    initializeCaptcha();

    const submitButton = document.querySelector('.js-form-submit');
    submitButton &&
        submitButton.addEventListener('click', (e) => {
            const form = document.querySelector('.js-form');
            const recaptchaResponse =
                document.getElementById('recaptcha-response');
            // Show loader
            const loader = document.querySelector('.js-form-loader');
            loader && loader.classList.add('show');

            const formIsValid = initFormValidation(form);
            if (formIsValid) {
                recaptchaSiteVerify(recaptchaResponse.value)
                    .then((result) => {
                        if (result === true) {
                            fetchData();

                            initializeCaptcha();
                        } else {
                            console.error('Verification failed.');
                            showSubmitError(
                                'Verification failed. Please refresh the page and try again'
                            );
                        }
                        loader && loader.classList.remove('show');
                    })
                    .catch((error) => {
                        showSubmitError(error);
                        loader && loader.classList.remove('show');
                    });
            } else {
                loader && loader.classList.remove('show');
            }
        });
};

document.defaultView.addEventListener(
    'DOMContentLoaded',
    initPlaidSearch,
    false
);

// Initialize dynamic block preview (editor).
if (window.acf) {
    window.acf.addAction('render_block_preview', initPlaidSearch);
}
